<template>
  <IonItem
    class="photo-input-item"
    button
    :detail="false"
    :color="gray ? 'whitesmoke' : 'white'"
    lines="full"
    :id="`photoInput-${title}`"
    @click="onRowClick()"
  >
    <IonLabel color="light">
      <div class="font-medium pl-5">{{ title }}</div>
    </IonLabel>
    <div v-if="existingPhoto?.url || base64" class="my-2 size-16 rounded-md overflow-hidden" slot="end">
      <img class="object-cover size-full" :src="base64 ? `data:image/jpeg;base64, ` + base64 : existingPhoto?.url" />
    </div>
    <div v-else class="my-2 size-16 flex items-center justify-end rounded-md overflow-hidden" slot="end">
      <i class="icon-image text-3xl text-gray-500/50"></i>
    </div>
  </IonItem>
  <PhotoModal
    ref="photoModal"
    :title="title"
    :photo="existingPhoto"
    :base64="base64"
    @take-photo="retakePhoto()"
  ></PhotoModal>
</template>

<script setup lang="ts">
import { useCamera } from '@/composables/use-camera';
import { useToast } from '@/composables/use-toast';
import PhotoModal from '@/components/photos/PhotoModal.vue';
import { IonItem, IonLabel } from '@ionic/vue';
import { IDocument } from '@ncss/models/dist/v3';
import { ref } from 'vue';

const props = defineProps<{
  title: string;
  gray?: boolean;
  clearable?: boolean;
  existingPhoto?: IDocument;
}>();

const photoModal = ref<InstanceType<typeof PhotoModal>>();
const toast = useToast();
const base64 = defineModel({ type: String });
const { getPhoto } = useCamera();

async function retakePhoto() {
  await updateBase64();
}

async function updateBase64() {
  const res = await getPhoto();
  if (!res.error) {
    base64.value = res.base64;
  } else if (res.errorMsg) {
    toast.errorToast(res.errorMsg || 'Unable to get photo');
  }
}

async function onRowClick() {
  if (!base64.value && !props.existingPhoto) {
    await updateBase64();
  } else {
    photoModal.value?.present();
  }
}

defineExpose({ present: () => onRowClick() });
</script>

<style scoped>
ion-item.photo-input-item::part(native) {
  --border-width: 1px;
}
ion-item.photo-input-item {
  --padding-start: 0px;
  --inline-padding-start: 0px;
  --padding-end: 0px;
  --inline-padding-end: 0px;
}
</style>
